import { render } from "./GooglePlayButton.vue?vue&type=template&id=3e935126&scoped=true&ts=true"
import script from "./GooglePlayButton.vue?vue&type=script&lang=ts"
export * from "./GooglePlayButton.vue?vue&type=script&lang=ts"

import "./GooglePlayButton.vue?vue&type=style&index=0&id=3e935126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e935126"]])

export default __exports__